import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Button } from '@openedx/paragon';

import courseOutlineMessages from '@src/course-home/outline-tab/messages';
import CompletionIcon from './generic/CompletionIcon';
import OutlineItemTitle from './generic/OutlineItemTitle';
import { ForwardArrow } from './generic/icons';

const SidebarSection = ({ section, handleSelectSection }) => {
  const intl = useIntl();
  const {
    id,
    complete,
    title,
    completionStat,
  } = section;

  const sectionTitle = (
    <OutlineItemTitle
      icon={<CompletionIcon completionStat={completionStat} />}
      title={title}
      screenreaderMessage={intl.formatMessage(complete
        ? courseOutlineMessages.completedSection
        : courseOutlineMessages.incompleteSection)}
      fontWeight="medium"
    />
  );

  return (
    <Button
      variant="link"
      className="p-0 pr-3 text-left justify-content-between text-primary-500 outline-item-hover text-decoration-none"
      onClick={() => handleSelectSection(id)}
      iconAfter={ForwardArrow}
      block
    >
      {sectionTitle}
    </Button>
  );
};

SidebarSection.propTypes = {
  section: PropTypes.shape({
    complete: PropTypes.bool,
    id: PropTypes.string,
    title: PropTypes.string,
    sequenceIds: PropTypes.arrayOf(PropTypes.string),
    completionStat: PropTypes.shape({
      completed: PropTypes.number,
      total: PropTypes.number,
    }),
  }).isRequired,
  handleSelectSection: PropTypes.func.isRequired,
};

export default SidebarSection;
